import iconMoneyBack from '../../assets/images/icon-moneyback-guarantee-check.png';
import checkIcon from '../../assets/images/check-bold.svg';
import primaryButtonStyle from '../UI/primaryButtonStyle';

export const useStyles = () => ({
	bold: {
		fontWeight: 700,
	},
	center: {
		textAlign: 'center',
	},
	popupBackdrop: {
		position: 'fixed',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		background: 'rgba(255, 255, 255, 0.95)',
		zIndex: 10000,
		overflow: 'auto',
		padding: 10,
	},
	popup: {
		fontFamily: 'Spartan, sans-serif',
		fontWeight: 400,
		color: '#283339',
		width: '100%',
		maxWidth: 1076,
		minHeight: 230,
		background: '#FFFFFF',
		boxSizing: 'border-box',
		boxShadow: '0px 10px 20px rgba(147, 153, 156, 0.15)',
		borderRadius: 16,
		margin: '30px auto',
	},
	header: {
		position: 'relative',
		fontSize: 18,
		fontWeight: 700,
		padding: '10px 30px',
		textAlign: 'center',
		color: '#ffffff',
		background: '#28D799',
		borderRadius: '16px 16px 0 0',
	},
	closeBtn: {
		position: 'absolute',
		top: 6,
		right: 10,
		fontSize: 26,
		color: '#ffffff',
		opacity: 0.6,
		cursor: 'pointer',
	},
	body: {
		padding: '40px 30px',
	},
	title: {
		fontSize: 36,
		fontWeight: 700,
		textAlign: 'center',
		marginBottom: 15,
	},
	subTitle: {
		fontSize: 16,
		fontWeight: 500,
		textAlign: 'center',
		marginBottom: 50,
	},
	features: {
		display: 'flex',
		borderTop: '1px solid #93999C',
		paddingTop: 20,
		paddingBottom: 20,
	},
	feature: {
		borderRight: '1px solid #93999C',
		paddingRight: 20,
		marginRight: 20,
		flex: 'auto',
		'& li': {
			padding: 0,
		},
		'&:nth-last-child(1)': {
			border: 'none',
			paddingRight: 0,
			marginRight: 0,
		},
	},
	featureIcon: {
		minWidth: 45,
		marginTop: 0,
	},
	featureIconHead: {
		minWidth: 45,
		marginBottom: 15,
	},
	featureItemHead: {
		marginBottom: 15,
		'& span': {
			fontSize: 18,
			fontWeight: 700,
		},
		'& p': {
			fontSize: 14,
			fontWeight: 500,
			color: '#525B60',
		}
	},
	featureItemRow: {
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: 1,
			left: 6,
			width: 20,
			height: 20,
			backgroundColor: '#12af5a',
			WebkitMaskImage: `url(${checkIcon})`,
			maskImage: `url(${checkIcon})`,
			WebkitMaskSize: '100% 100%',
			maskSize: '100% 100%',
		},
		paddingLeft: 45,
		fontSize: 14,
		fontWeight: 600,
		color: '#525B60',
		'& span': {
			fontSize: 14,
			fontWeight: 600,
			color: '#525B60',
		},
	},
	featureItemRowIcons: {
		display: 'flex',
		'& img': {
			marginLeft: 10,
		},
		'& span': {
			whiteSpace: 'nowrap',
		},
		'& span + span': {
			maxWidth: 180,
		}
	},
	btn: {
		...primaryButtonStyle(),
		maxWidth: 320,
		padding: 15,
		margin: '10px auto 20px',
		fontSize: 16,
	},
	mbgWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: 20,
	},
	mbg: {
		position: 'relative',
		fontSize: 15,
		fontWeight: 700,
		lineHeight: '24px',
		color: '#283339',
		padding: '5px 15px 5px 30px',
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: 4,
			left: 0,
			width: 23,
			height: 22,
			backgroundSize: 'cover',
			backgroundImage: `url(${iconMoneyBack})`,
		},
	},
	recommendedWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		color: '#93999C',
		fontSize: 14,
		fontWeight: 700,
		padding: 10,
		marginBottom: 20,
		'&>*': {
			margin: '0 12px',
		}
	},
	linkGrey: {
		display: 'inline-block',
		color: '#93999C',
		fontSize: 13,
		fontWeight: 600,
		textDecoration: 'underline',
		cursor: 'pointer',
	},
	'@media (max-width: 760px)': {
		popup: {
			flexDirection: 'column',
			textAlign: 'center',
		},
		title: {
			fontSize: 24,
			marginTop: 30,
		},
		btn: {
			maxWidth: '100%',
		},
		features: {
			flexDirection: 'column',
			maxWidth: 400,
			margin: '0 auto',
			'& $feature': {
				border: 'none',
			}
		},
	},
});